var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8718 16.2692V10.2436C18.8718 6.54385 16.9074 3.44667 13.4487 2.62718V1.80769C13.4487 0.807436 12.6413 0 11.641 0C10.6408 0 9.83333 0.807436 9.83333 1.80769V2.62718C6.38667 3.44667 4.41026 6.53179 4.41026 10.2436V16.2692L2 18.6795V19.8846H21.2821V18.6795L18.8718 16.2692ZM11.641 23.5001C12.9667 23.5001 14.0513 22.4155 14.0513 21.0899H9.23077C9.23077 22.4155 10.3154 23.5001 11.641 23.5001ZM6.82053 17.4741H16.4616V10.2434C16.4616 7.25463 14.6418 4.82027 11.641 4.82027C8.64027 4.82027 6.82053 7.25463 6.82053 10.2434V17.4741Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.e5bc75d65eca4f98feacc3682cd21b41.svg";
export { ForwardRef as ReactComponent };